// source: activity/activity.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var authz_annotations_pb = require('../authz/annotations_pb.js');
goog.object.extend(proto, authz_annotations_pb);
goog.exportSymbol('proto.activity.ACTIVITY_ACTOR_TYPE', null, global);
goog.exportSymbol('proto.activity.ACTIVITY_CITATION_TYPE', null, global);
goog.exportSymbol('proto.activity.ActivityEntryCount', null, global);
goog.exportSymbol('proto.activity.ActivityLogCitation', null, global);
goog.exportSymbol('proto.activity.ActivityLogEntries', null, global);
goog.exportSymbol('proto.activity.ActivityLogEntry', null, global);
goog.exportSymbol('proto.activity.ActivityLogError', null, global);
goog.exportSymbol('proto.activity.ActivityLogErrorsResponse', null, global);
goog.exportSymbol('proto.activity.ActivityLogInfo', null, global);
goog.exportSymbol('proto.activity.ActivityLogInfosResponse', null, global);
goog.exportSymbol('proto.activity.GetActivityCountCitiationRequest', null, global);
goog.exportSymbol('proto.activity.GetActivityCountRequest', null, global);
goog.exportSymbol('proto.activity.GetActivityLogCitationRequest', null, global);
goog.exportSymbol('proto.activity.GetActivityLogErrorsRequest', null, global);
goog.exportSymbol('proto.activity.GetActivityLogInfosRequest', null, global);
goog.exportSymbol('proto.activity.GetActivityLogRequest', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.activity.GetActivityLogRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.activity.GetActivityLogRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.activity.GetActivityLogRequest.displayName = 'proto.activity.GetActivityLogRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.activity.GetActivityLogCitationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.activity.GetActivityLogCitationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.activity.GetActivityLogCitationRequest.displayName = 'proto.activity.GetActivityLogCitationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.activity.ActivityLogEntry = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.activity.ActivityLogEntry.repeatedFields_, null);
};
goog.inherits(proto.activity.ActivityLogEntry, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.activity.ActivityLogEntry.displayName = 'proto.activity.ActivityLogEntry';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.activity.ActivityLogCitation = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.activity.ActivityLogCitation, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.activity.ActivityLogCitation.displayName = 'proto.activity.ActivityLogCitation';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.activity.ActivityLogInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.activity.ActivityLogInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.activity.ActivityLogInfo.displayName = 'proto.activity.ActivityLogInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.activity.ActivityLogError = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.activity.ActivityLogError, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.activity.ActivityLogError.displayName = 'proto.activity.ActivityLogError';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.activity.ActivityLogEntries = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.activity.ActivityLogEntries.repeatedFields_, null);
};
goog.inherits(proto.activity.ActivityLogEntries, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.activity.ActivityLogEntries.displayName = 'proto.activity.ActivityLogEntries';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.activity.GetActivityCountRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.activity.GetActivityCountRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.activity.GetActivityCountRequest.displayName = 'proto.activity.GetActivityCountRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.activity.GetActivityCountCitiationRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.activity.GetActivityCountCitiationRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.activity.GetActivityCountCitiationRequest.displayName = 'proto.activity.GetActivityCountCitiationRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.activity.ActivityEntryCount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.activity.ActivityEntryCount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.activity.ActivityEntryCount.displayName = 'proto.activity.ActivityEntryCount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.activity.GetActivityLogInfosRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.activity.GetActivityLogInfosRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.activity.GetActivityLogInfosRequest.displayName = 'proto.activity.GetActivityLogInfosRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.activity.ActivityLogInfosResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.activity.ActivityLogInfosResponse.repeatedFields_, null);
};
goog.inherits(proto.activity.ActivityLogInfosResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.activity.ActivityLogInfosResponse.displayName = 'proto.activity.ActivityLogInfosResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.activity.GetActivityLogErrorsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.activity.GetActivityLogErrorsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.activity.GetActivityLogErrorsRequest.displayName = 'proto.activity.GetActivityLogErrorsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.activity.ActivityLogErrorsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.activity.ActivityLogErrorsResponse.repeatedFields_, null);
};
goog.inherits(proto.activity.ActivityLogErrorsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.activity.ActivityLogErrorsResponse.displayName = 'proto.activity.ActivityLogErrorsResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.activity.GetActivityLogRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.activity.GetActivityLogRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.activity.GetActivityLogRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.activity.GetActivityLogRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    beginTime: (f = msg.getBeginTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    entriesPerPage: jspb.Message.getFieldWithDefault(msg, 2, 0),
    pageNumber: jspb.Message.getFieldWithDefault(msg, 3, 0),
    auditId: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.activity.GetActivityLogRequest}
 */
proto.activity.GetActivityLogRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.activity.GetActivityLogRequest;
  return proto.activity.GetActivityLogRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.activity.GetActivityLogRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.activity.GetActivityLogRequest}
 */
proto.activity.GetActivityLogRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setBeginTime(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setEntriesPerPage(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuditId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.activity.GetActivityLogRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.activity.GetActivityLogRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.activity.GetActivityLogRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.activity.GetActivityLogRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBeginTime();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEntriesPerPage();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getAuditId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp begin_time = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.activity.GetActivityLogRequest.prototype.getBeginTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.activity.GetActivityLogRequest} returns this
*/
proto.activity.GetActivityLogRequest.prototype.setBeginTime = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.activity.GetActivityLogRequest} returns this
 */
proto.activity.GetActivityLogRequest.prototype.clearBeginTime = function() {
  return this.setBeginTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.activity.GetActivityLogRequest.prototype.hasBeginTime = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 entries_per_page = 2;
 * @return {number}
 */
proto.activity.GetActivityLogRequest.prototype.getEntriesPerPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.activity.GetActivityLogRequest} returns this
 */
proto.activity.GetActivityLogRequest.prototype.setEntriesPerPage = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 page_number = 3;
 * @return {number}
 */
proto.activity.GetActivityLogRequest.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.activity.GetActivityLogRequest} returns this
 */
proto.activity.GetActivityLogRequest.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string audit_id = 4;
 * @return {string}
 */
proto.activity.GetActivityLogRequest.prototype.getAuditId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.activity.GetActivityLogRequest} returns this
 */
proto.activity.GetActivityLogRequest.prototype.setAuditId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.activity.GetActivityLogCitationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.activity.GetActivityLogCitationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.activity.GetActivityLogCitationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.activity.GetActivityLogCitationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    beginTime: (f = msg.getBeginTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    entriesPerPage: jspb.Message.getFieldWithDefault(msg, 2, 0),
    pageNumber: jspb.Message.getFieldWithDefault(msg, 3, 0),
    auditId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    citationType: jspb.Message.getFieldWithDefault(msg, 5, 0),
    citationId: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.activity.GetActivityLogCitationRequest}
 */
proto.activity.GetActivityLogCitationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.activity.GetActivityLogCitationRequest;
  return proto.activity.GetActivityLogCitationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.activity.GetActivityLogCitationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.activity.GetActivityLogCitationRequest}
 */
proto.activity.GetActivityLogCitationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setBeginTime(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setEntriesPerPage(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPageNumber(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAuditId(value);
      break;
    case 5:
      var value = /** @type {!proto.activity.ACTIVITY_CITATION_TYPE} */ (reader.readEnum());
      msg.setCitationType(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setCitationId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.activity.GetActivityLogCitationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.activity.GetActivityLogCitationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.activity.GetActivityLogCitationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.activity.GetActivityLogCitationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBeginTime();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEntriesPerPage();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getPageNumber();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getAuditId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCitationType();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getCitationId();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp begin_time = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.activity.GetActivityLogCitationRequest.prototype.getBeginTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.activity.GetActivityLogCitationRequest} returns this
*/
proto.activity.GetActivityLogCitationRequest.prototype.setBeginTime = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.activity.GetActivityLogCitationRequest} returns this
 */
proto.activity.GetActivityLogCitationRequest.prototype.clearBeginTime = function() {
  return this.setBeginTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.activity.GetActivityLogCitationRequest.prototype.hasBeginTime = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int32 entries_per_page = 2;
 * @return {number}
 */
proto.activity.GetActivityLogCitationRequest.prototype.getEntriesPerPage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.activity.GetActivityLogCitationRequest} returns this
 */
proto.activity.GetActivityLogCitationRequest.prototype.setEntriesPerPage = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 page_number = 3;
 * @return {number}
 */
proto.activity.GetActivityLogCitationRequest.prototype.getPageNumber = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.activity.GetActivityLogCitationRequest} returns this
 */
proto.activity.GetActivityLogCitationRequest.prototype.setPageNumber = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional string audit_id = 4;
 * @return {string}
 */
proto.activity.GetActivityLogCitationRequest.prototype.getAuditId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.activity.GetActivityLogCitationRequest} returns this
 */
proto.activity.GetActivityLogCitationRequest.prototype.setAuditId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional ACTIVITY_CITATION_TYPE citation_type = 5;
 * @return {!proto.activity.ACTIVITY_CITATION_TYPE}
 */
proto.activity.GetActivityLogCitationRequest.prototype.getCitationType = function() {
  return /** @type {!proto.activity.ACTIVITY_CITATION_TYPE} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.activity.ACTIVITY_CITATION_TYPE} value
 * @return {!proto.activity.GetActivityLogCitationRequest} returns this
 */
proto.activity.GetActivityLogCitationRequest.prototype.setCitationType = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional string citation_id = 6;
 * @return {string}
 */
proto.activity.GetActivityLogCitationRequest.prototype.getCitationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.activity.GetActivityLogCitationRequest} returns this
 */
proto.activity.GetActivityLogCitationRequest.prototype.setCitationId = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.activity.ActivityLogEntry.repeatedFields_ = [9,10,11];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.activity.ActivityLogEntry.prototype.toObject = function(opt_includeInstance) {
  return proto.activity.ActivityLogEntry.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.activity.ActivityLogEntry} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.activity.ActivityLogEntry.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    accountId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    actorType: jspb.Message.getFieldWithDefault(msg, 4, 0),
    actor: jspb.Message.getFieldWithDefault(msg, 5, ""),
    message: jspb.Message.getFieldWithDefault(msg, 6, ""),
    citationCount: jspb.Message.getFieldWithDefault(msg, 7, 0),
    infoCount: jspb.Message.getFieldWithDefault(msg, 8, 0),
    citationsList: jspb.Message.toObjectList(msg.getCitationsList(),
    proto.activity.ActivityLogCitation.toObject, includeInstance),
    infosList: jspb.Message.toObjectList(msg.getInfosList(),
    proto.activity.ActivityLogInfo.toObject, includeInstance),
    errorsList: jspb.Message.toObjectList(msg.getErrorsList(),
    proto.activity.ActivityLogError.toObject, includeInstance),
    isError: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
    errorCount: jspb.Message.getFieldWithDefault(msg, 13, 0),
    hasInfo: jspb.Message.getBooleanFieldWithDefault(msg, 14, false),
    hasError: jspb.Message.getBooleanFieldWithDefault(msg, 15, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.activity.ActivityLogEntry}
 */
proto.activity.ActivityLogEntry.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.activity.ActivityLogEntry;
  return proto.activity.ActivityLogEntry.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.activity.ActivityLogEntry} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.activity.ActivityLogEntry}
 */
proto.activity.ActivityLogEntry.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 4:
      var value = /** @type {!proto.activity.ACTIVITY_ACTOR_TYPE} */ (reader.readEnum());
      msg.setActorType(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setActor(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCitationCount(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setInfoCount(value);
      break;
    case 9:
      var value = new proto.activity.ActivityLogCitation;
      reader.readMessage(value,proto.activity.ActivityLogCitation.deserializeBinaryFromReader);
      msg.addCitations(value);
      break;
    case 10:
      var value = new proto.activity.ActivityLogInfo;
      reader.readMessage(value,proto.activity.ActivityLogInfo.deserializeBinaryFromReader);
      msg.addInfos(value);
      break;
    case 11:
      var value = new proto.activity.ActivityLogError;
      reader.readMessage(value,proto.activity.ActivityLogError.deserializeBinaryFromReader);
      msg.addErrors(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsError(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setErrorCount(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasInfo(value);
      break;
    case 15:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHasError(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.activity.ActivityLogEntry.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.activity.ActivityLogEntry.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.activity.ActivityLogEntry} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.activity.ActivityLogEntry.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getActorType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getActor();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCitationCount();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getInfoCount();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getCitationsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.activity.ActivityLogCitation.serializeBinaryToWriter
    );
  }
  f = message.getInfosList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      10,
      f,
      proto.activity.ActivityLogInfo.serializeBinaryToWriter
    );
  }
  f = message.getErrorsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      11,
      f,
      proto.activity.ActivityLogError.serializeBinaryToWriter
    );
  }
  f = message.getIsError();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getErrorCount();
  if (f !== 0) {
    writer.writeInt32(
      13,
      f
    );
  }
  f = message.getHasInfo();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
  f = message.getHasError();
  if (f) {
    writer.writeBool(
      15,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.activity.ActivityLogEntry.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.activity.ActivityLogEntry} returns this
 */
proto.activity.ActivityLogEntry.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp created_at = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.activity.ActivityLogEntry.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.activity.ActivityLogEntry} returns this
*/
proto.activity.ActivityLogEntry.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.activity.ActivityLogEntry} returns this
 */
proto.activity.ActivityLogEntry.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.activity.ActivityLogEntry.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string account_id = 3;
 * @return {string}
 */
proto.activity.ActivityLogEntry.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.activity.ActivityLogEntry} returns this
 */
proto.activity.ActivityLogEntry.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional ACTIVITY_ACTOR_TYPE actor_type = 4;
 * @return {!proto.activity.ACTIVITY_ACTOR_TYPE}
 */
proto.activity.ActivityLogEntry.prototype.getActorType = function() {
  return /** @type {!proto.activity.ACTIVITY_ACTOR_TYPE} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.activity.ACTIVITY_ACTOR_TYPE} value
 * @return {!proto.activity.ActivityLogEntry} returns this
 */
proto.activity.ActivityLogEntry.prototype.setActorType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional string actor = 5;
 * @return {string}
 */
proto.activity.ActivityLogEntry.prototype.getActor = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.activity.ActivityLogEntry} returns this
 */
proto.activity.ActivityLogEntry.prototype.setActor = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string message = 6;
 * @return {string}
 */
proto.activity.ActivityLogEntry.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.activity.ActivityLogEntry} returns this
 */
proto.activity.ActivityLogEntry.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int32 citation_count = 7;
 * @return {number}
 */
proto.activity.ActivityLogEntry.prototype.getCitationCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.activity.ActivityLogEntry} returns this
 */
proto.activity.ActivityLogEntry.prototype.setCitationCount = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int32 info_count = 8;
 * @return {number}
 */
proto.activity.ActivityLogEntry.prototype.getInfoCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.activity.ActivityLogEntry} returns this
 */
proto.activity.ActivityLogEntry.prototype.setInfoCount = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * repeated ActivityLogCitation citations = 9;
 * @return {!Array<!proto.activity.ActivityLogCitation>}
 */
proto.activity.ActivityLogEntry.prototype.getCitationsList = function() {
  return /** @type{!Array<!proto.activity.ActivityLogCitation>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.activity.ActivityLogCitation, 9));
};


/**
 * @param {!Array<!proto.activity.ActivityLogCitation>} value
 * @return {!proto.activity.ActivityLogEntry} returns this
*/
proto.activity.ActivityLogEntry.prototype.setCitationsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.activity.ActivityLogCitation=} opt_value
 * @param {number=} opt_index
 * @return {!proto.activity.ActivityLogCitation}
 */
proto.activity.ActivityLogEntry.prototype.addCitations = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.activity.ActivityLogCitation, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.activity.ActivityLogEntry} returns this
 */
proto.activity.ActivityLogEntry.prototype.clearCitationsList = function() {
  return this.setCitationsList([]);
};


/**
 * repeated ActivityLogInfo infos = 10;
 * @return {!Array<!proto.activity.ActivityLogInfo>}
 */
proto.activity.ActivityLogEntry.prototype.getInfosList = function() {
  return /** @type{!Array<!proto.activity.ActivityLogInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.activity.ActivityLogInfo, 10));
};


/**
 * @param {!Array<!proto.activity.ActivityLogInfo>} value
 * @return {!proto.activity.ActivityLogEntry} returns this
*/
proto.activity.ActivityLogEntry.prototype.setInfosList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 10, value);
};


/**
 * @param {!proto.activity.ActivityLogInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.activity.ActivityLogInfo}
 */
proto.activity.ActivityLogEntry.prototype.addInfos = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 10, opt_value, proto.activity.ActivityLogInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.activity.ActivityLogEntry} returns this
 */
proto.activity.ActivityLogEntry.prototype.clearInfosList = function() {
  return this.setInfosList([]);
};


/**
 * repeated ActivityLogError errors = 11;
 * @return {!Array<!proto.activity.ActivityLogError>}
 */
proto.activity.ActivityLogEntry.prototype.getErrorsList = function() {
  return /** @type{!Array<!proto.activity.ActivityLogError>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.activity.ActivityLogError, 11));
};


/**
 * @param {!Array<!proto.activity.ActivityLogError>} value
 * @return {!proto.activity.ActivityLogEntry} returns this
*/
proto.activity.ActivityLogEntry.prototype.setErrorsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 11, value);
};


/**
 * @param {!proto.activity.ActivityLogError=} opt_value
 * @param {number=} opt_index
 * @return {!proto.activity.ActivityLogError}
 */
proto.activity.ActivityLogEntry.prototype.addErrors = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 11, opt_value, proto.activity.ActivityLogError, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.activity.ActivityLogEntry} returns this
 */
proto.activity.ActivityLogEntry.prototype.clearErrorsList = function() {
  return this.setErrorsList([]);
};


/**
 * optional bool is_error = 12;
 * @return {boolean}
 */
proto.activity.ActivityLogEntry.prototype.getIsError = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.activity.ActivityLogEntry} returns this
 */
proto.activity.ActivityLogEntry.prototype.setIsError = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional int32 error_count = 13;
 * @return {number}
 */
proto.activity.ActivityLogEntry.prototype.getErrorCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.activity.ActivityLogEntry} returns this
 */
proto.activity.ActivityLogEntry.prototype.setErrorCount = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional bool has_info = 14;
 * @return {boolean}
 */
proto.activity.ActivityLogEntry.prototype.getHasInfo = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.activity.ActivityLogEntry} returns this
 */
proto.activity.ActivityLogEntry.prototype.setHasInfo = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};


/**
 * optional bool has_error = 15;
 * @return {boolean}
 */
proto.activity.ActivityLogEntry.prototype.getHasError = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 15, false));
};


/**
 * @param {boolean} value
 * @return {!proto.activity.ActivityLogEntry} returns this
 */
proto.activity.ActivityLogEntry.prototype.setHasError = function(value) {
  return jspb.Message.setProto3BooleanField(this, 15, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.activity.ActivityLogCitation.prototype.toObject = function(opt_includeInstance) {
  return proto.activity.ActivityLogCitation.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.activity.ActivityLogCitation} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.activity.ActivityLogCitation.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    description: jspb.Message.getFieldWithDefault(msg, 2, ""),
    citationType: jspb.Message.getFieldWithDefault(msg, 3, 0),
    citationId: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.activity.ActivityLogCitation}
 */
proto.activity.ActivityLogCitation.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.activity.ActivityLogCitation;
  return proto.activity.ActivityLogCitation.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.activity.ActivityLogCitation} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.activity.ActivityLogCitation}
 */
proto.activity.ActivityLogCitation.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 3:
      var value = /** @type {!proto.activity.ACTIVITY_CITATION_TYPE} */ (reader.readEnum());
      msg.setCitationType(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCitationId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.activity.ActivityLogCitation.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.activity.ActivityLogCitation.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.activity.ActivityLogCitation} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.activity.ActivityLogCitation.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCitationType();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getCitationId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.activity.ActivityLogCitation.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.activity.ActivityLogCitation} returns this
 */
proto.activity.ActivityLogCitation.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string description = 2;
 * @return {string}
 */
proto.activity.ActivityLogCitation.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.activity.ActivityLogCitation} returns this
 */
proto.activity.ActivityLogCitation.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional ACTIVITY_CITATION_TYPE citation_type = 3;
 * @return {!proto.activity.ACTIVITY_CITATION_TYPE}
 */
proto.activity.ActivityLogCitation.prototype.getCitationType = function() {
  return /** @type {!proto.activity.ACTIVITY_CITATION_TYPE} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.activity.ACTIVITY_CITATION_TYPE} value
 * @return {!proto.activity.ActivityLogCitation} returns this
 */
proto.activity.ActivityLogCitation.prototype.setCitationType = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string citation_id = 4;
 * @return {string}
 */
proto.activity.ActivityLogCitation.prototype.getCitationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.activity.ActivityLogCitation} returns this
 */
proto.activity.ActivityLogCitation.prototype.setCitationId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.activity.ActivityLogInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.activity.ActivityLogInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.activity.ActivityLogInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.activity.ActivityLogInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    description: jspb.Message.getFieldWithDefault(msg, 2, ""),
    information: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.activity.ActivityLogInfo}
 */
proto.activity.ActivityLogInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.activity.ActivityLogInfo;
  return proto.activity.ActivityLogInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.activity.ActivityLogInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.activity.ActivityLogInfo}
 */
proto.activity.ActivityLogInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setInformation(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.activity.ActivityLogInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.activity.ActivityLogInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.activity.ActivityLogInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.activity.ActivityLogInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getInformation();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.activity.ActivityLogInfo.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.activity.ActivityLogInfo} returns this
 */
proto.activity.ActivityLogInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string description = 2;
 * @return {string}
 */
proto.activity.ActivityLogInfo.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.activity.ActivityLogInfo} returns this
 */
proto.activity.ActivityLogInfo.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string information = 3;
 * @return {string}
 */
proto.activity.ActivityLogInfo.prototype.getInformation = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.activity.ActivityLogInfo} returns this
 */
proto.activity.ActivityLogInfo.prototype.setInformation = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.activity.ActivityLogError.prototype.toObject = function(opt_includeInstance) {
  return proto.activity.ActivityLogError.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.activity.ActivityLogError} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.activity.ActivityLogError.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    errorMsg: jspb.Message.getFieldWithDefault(msg, 2, ""),
    errorDetails: jspb.Message.getFieldWithDefault(msg, 3, ""),
    errorPath: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.activity.ActivityLogError}
 */
proto.activity.ActivityLogError.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.activity.ActivityLogError;
  return proto.activity.ActivityLogError.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.activity.ActivityLogError} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.activity.ActivityLogError}
 */
proto.activity.ActivityLogError.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrorMsg(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrorDetails(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setErrorPath(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.activity.ActivityLogError.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.activity.ActivityLogError.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.activity.ActivityLogError} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.activity.ActivityLogError.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getErrorMsg();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getErrorDetails();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getErrorPath();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.activity.ActivityLogError.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.activity.ActivityLogError} returns this
 */
proto.activity.ActivityLogError.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string error_msg = 2;
 * @return {string}
 */
proto.activity.ActivityLogError.prototype.getErrorMsg = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.activity.ActivityLogError} returns this
 */
proto.activity.ActivityLogError.prototype.setErrorMsg = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string error_details = 3;
 * @return {string}
 */
proto.activity.ActivityLogError.prototype.getErrorDetails = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.activity.ActivityLogError} returns this
 */
proto.activity.ActivityLogError.prototype.setErrorDetails = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string error_path = 4;
 * @return {string}
 */
proto.activity.ActivityLogError.prototype.getErrorPath = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.activity.ActivityLogError} returns this
 */
proto.activity.ActivityLogError.prototype.setErrorPath = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.activity.ActivityLogEntries.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.activity.ActivityLogEntries.prototype.toObject = function(opt_includeInstance) {
  return proto.activity.ActivityLogEntries.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.activity.ActivityLogEntries} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.activity.ActivityLogEntries.toObject = function(includeInstance, msg) {
  var f, obj = {
    activityLogEntriesList: jspb.Message.toObjectList(msg.getActivityLogEntriesList(),
    proto.activity.ActivityLogEntry.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.activity.ActivityLogEntries}
 */
proto.activity.ActivityLogEntries.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.activity.ActivityLogEntries;
  return proto.activity.ActivityLogEntries.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.activity.ActivityLogEntries} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.activity.ActivityLogEntries}
 */
proto.activity.ActivityLogEntries.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.activity.ActivityLogEntry;
      reader.readMessage(value,proto.activity.ActivityLogEntry.deserializeBinaryFromReader);
      msg.addActivityLogEntries(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.activity.ActivityLogEntries.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.activity.ActivityLogEntries.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.activity.ActivityLogEntries} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.activity.ActivityLogEntries.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getActivityLogEntriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.activity.ActivityLogEntry.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ActivityLogEntry activity_log_entries = 1;
 * @return {!Array<!proto.activity.ActivityLogEntry>}
 */
proto.activity.ActivityLogEntries.prototype.getActivityLogEntriesList = function() {
  return /** @type{!Array<!proto.activity.ActivityLogEntry>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.activity.ActivityLogEntry, 1));
};


/**
 * @param {!Array<!proto.activity.ActivityLogEntry>} value
 * @return {!proto.activity.ActivityLogEntries} returns this
*/
proto.activity.ActivityLogEntries.prototype.setActivityLogEntriesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.activity.ActivityLogEntry=} opt_value
 * @param {number=} opt_index
 * @return {!proto.activity.ActivityLogEntry}
 */
proto.activity.ActivityLogEntries.prototype.addActivityLogEntries = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.activity.ActivityLogEntry, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.activity.ActivityLogEntries} returns this
 */
proto.activity.ActivityLogEntries.prototype.clearActivityLogEntriesList = function() {
  return this.setActivityLogEntriesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.activity.GetActivityCountRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.activity.GetActivityCountRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.activity.GetActivityCountRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.activity.GetActivityCountRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    beginTime: (f = msg.getBeginTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.activity.GetActivityCountRequest}
 */
proto.activity.GetActivityCountRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.activity.GetActivityCountRequest;
  return proto.activity.GetActivityCountRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.activity.GetActivityCountRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.activity.GetActivityCountRequest}
 */
proto.activity.GetActivityCountRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setBeginTime(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.activity.GetActivityCountRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.activity.GetActivityCountRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.activity.GetActivityCountRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.activity.GetActivityCountRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBeginTime();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Timestamp begin_time = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.activity.GetActivityCountRequest.prototype.getBeginTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.activity.GetActivityCountRequest} returns this
*/
proto.activity.GetActivityCountRequest.prototype.setBeginTime = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.activity.GetActivityCountRequest} returns this
 */
proto.activity.GetActivityCountRequest.prototype.clearBeginTime = function() {
  return this.setBeginTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.activity.GetActivityCountRequest.prototype.hasBeginTime = function() {
  return jspb.Message.getField(this, 1) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.activity.GetActivityCountCitiationRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.activity.GetActivityCountCitiationRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.activity.GetActivityCountCitiationRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.activity.GetActivityCountCitiationRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    beginTime: (f = msg.getBeginTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    citationType: jspb.Message.getFieldWithDefault(msg, 2, 0),
    citationId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.activity.GetActivityCountCitiationRequest}
 */
proto.activity.GetActivityCountCitiationRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.activity.GetActivityCountCitiationRequest;
  return proto.activity.GetActivityCountCitiationRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.activity.GetActivityCountCitiationRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.activity.GetActivityCountCitiationRequest}
 */
proto.activity.GetActivityCountCitiationRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setBeginTime(value);
      break;
    case 2:
      var value = /** @type {!proto.activity.ACTIVITY_CITATION_TYPE} */ (reader.readEnum());
      msg.setCitationType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCitationId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.activity.GetActivityCountCitiationRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.activity.GetActivityCountCitiationRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.activity.GetActivityCountCitiationRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.activity.GetActivityCountCitiationRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBeginTime();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCitationType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getCitationId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional google.protobuf.Timestamp begin_time = 1;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.activity.GetActivityCountCitiationRequest.prototype.getBeginTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 1));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.activity.GetActivityCountCitiationRequest} returns this
*/
proto.activity.GetActivityCountCitiationRequest.prototype.setBeginTime = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.activity.GetActivityCountCitiationRequest} returns this
 */
proto.activity.GetActivityCountCitiationRequest.prototype.clearBeginTime = function() {
  return this.setBeginTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.activity.GetActivityCountCitiationRequest.prototype.hasBeginTime = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ACTIVITY_CITATION_TYPE citation_type = 2;
 * @return {!proto.activity.ACTIVITY_CITATION_TYPE}
 */
proto.activity.GetActivityCountCitiationRequest.prototype.getCitationType = function() {
  return /** @type {!proto.activity.ACTIVITY_CITATION_TYPE} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.activity.ACTIVITY_CITATION_TYPE} value
 * @return {!proto.activity.GetActivityCountCitiationRequest} returns this
 */
proto.activity.GetActivityCountCitiationRequest.prototype.setCitationType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional string citation_id = 3;
 * @return {string}
 */
proto.activity.GetActivityCountCitiationRequest.prototype.getCitationId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.activity.GetActivityCountCitiationRequest} returns this
 */
proto.activity.GetActivityCountCitiationRequest.prototype.setCitationId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.activity.ActivityEntryCount.prototype.toObject = function(opt_includeInstance) {
  return proto.activity.ActivityEntryCount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.activity.ActivityEntryCount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.activity.ActivityEntryCount.toObject = function(includeInstance, msg) {
  var f, obj = {
    count: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.activity.ActivityEntryCount}
 */
proto.activity.ActivityEntryCount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.activity.ActivityEntryCount;
  return proto.activity.ActivityEntryCount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.activity.ActivityEntryCount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.activity.ActivityEntryCount}
 */
proto.activity.ActivityEntryCount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.activity.ActivityEntryCount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.activity.ActivityEntryCount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.activity.ActivityEntryCount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.activity.ActivityEntryCount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCount();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
};


/**
 * optional int32 count = 1;
 * @return {number}
 */
proto.activity.ActivityEntryCount.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.activity.ActivityEntryCount} returns this
 */
proto.activity.ActivityEntryCount.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.activity.GetActivityLogInfosRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.activity.GetActivityLogInfosRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.activity.GetActivityLogInfosRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.activity.GetActivityLogInfosRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    activityLogId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.activity.GetActivityLogInfosRequest}
 */
proto.activity.GetActivityLogInfosRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.activity.GetActivityLogInfosRequest;
  return proto.activity.GetActivityLogInfosRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.activity.GetActivityLogInfosRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.activity.GetActivityLogInfosRequest}
 */
proto.activity.GetActivityLogInfosRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setActivityLogId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.activity.GetActivityLogInfosRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.activity.GetActivityLogInfosRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.activity.GetActivityLogInfosRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.activity.GetActivityLogInfosRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getActivityLogId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string activity_log_id = 1;
 * @return {string}
 */
proto.activity.GetActivityLogInfosRequest.prototype.getActivityLogId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.activity.GetActivityLogInfosRequest} returns this
 */
proto.activity.GetActivityLogInfosRequest.prototype.setActivityLogId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.activity.ActivityLogInfosResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.activity.ActivityLogInfosResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.activity.ActivityLogInfosResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.activity.ActivityLogInfosResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.activity.ActivityLogInfosResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    infosList: jspb.Message.toObjectList(msg.getInfosList(),
    proto.activity.ActivityLogInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.activity.ActivityLogInfosResponse}
 */
proto.activity.ActivityLogInfosResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.activity.ActivityLogInfosResponse;
  return proto.activity.ActivityLogInfosResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.activity.ActivityLogInfosResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.activity.ActivityLogInfosResponse}
 */
proto.activity.ActivityLogInfosResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.activity.ActivityLogInfo;
      reader.readMessage(value,proto.activity.ActivityLogInfo.deserializeBinaryFromReader);
      msg.addInfos(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.activity.ActivityLogInfosResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.activity.ActivityLogInfosResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.activity.ActivityLogInfosResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.activity.ActivityLogInfosResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInfosList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.activity.ActivityLogInfo.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ActivityLogInfo infos = 1;
 * @return {!Array<!proto.activity.ActivityLogInfo>}
 */
proto.activity.ActivityLogInfosResponse.prototype.getInfosList = function() {
  return /** @type{!Array<!proto.activity.ActivityLogInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.activity.ActivityLogInfo, 1));
};


/**
 * @param {!Array<!proto.activity.ActivityLogInfo>} value
 * @return {!proto.activity.ActivityLogInfosResponse} returns this
*/
proto.activity.ActivityLogInfosResponse.prototype.setInfosList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.activity.ActivityLogInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.activity.ActivityLogInfo}
 */
proto.activity.ActivityLogInfosResponse.prototype.addInfos = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.activity.ActivityLogInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.activity.ActivityLogInfosResponse} returns this
 */
proto.activity.ActivityLogInfosResponse.prototype.clearInfosList = function() {
  return this.setInfosList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.activity.GetActivityLogErrorsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.activity.GetActivityLogErrorsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.activity.GetActivityLogErrorsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.activity.GetActivityLogErrorsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    activityLogId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.activity.GetActivityLogErrorsRequest}
 */
proto.activity.GetActivityLogErrorsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.activity.GetActivityLogErrorsRequest;
  return proto.activity.GetActivityLogErrorsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.activity.GetActivityLogErrorsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.activity.GetActivityLogErrorsRequest}
 */
proto.activity.GetActivityLogErrorsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setActivityLogId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.activity.GetActivityLogErrorsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.activity.GetActivityLogErrorsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.activity.GetActivityLogErrorsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.activity.GetActivityLogErrorsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getActivityLogId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string activity_log_id = 1;
 * @return {string}
 */
proto.activity.GetActivityLogErrorsRequest.prototype.getActivityLogId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.activity.GetActivityLogErrorsRequest} returns this
 */
proto.activity.GetActivityLogErrorsRequest.prototype.setActivityLogId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.activity.ActivityLogErrorsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.activity.ActivityLogErrorsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.activity.ActivityLogErrorsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.activity.ActivityLogErrorsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.activity.ActivityLogErrorsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    errorsList: jspb.Message.toObjectList(msg.getErrorsList(),
    proto.activity.ActivityLogError.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.activity.ActivityLogErrorsResponse}
 */
proto.activity.ActivityLogErrorsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.activity.ActivityLogErrorsResponse;
  return proto.activity.ActivityLogErrorsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.activity.ActivityLogErrorsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.activity.ActivityLogErrorsResponse}
 */
proto.activity.ActivityLogErrorsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.activity.ActivityLogError;
      reader.readMessage(value,proto.activity.ActivityLogError.deserializeBinaryFromReader);
      msg.addErrors(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.activity.ActivityLogErrorsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.activity.ActivityLogErrorsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.activity.ActivityLogErrorsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.activity.ActivityLogErrorsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getErrorsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.activity.ActivityLogError.serializeBinaryToWriter
    );
  }
};


/**
 * repeated ActivityLogError errors = 1;
 * @return {!Array<!proto.activity.ActivityLogError>}
 */
proto.activity.ActivityLogErrorsResponse.prototype.getErrorsList = function() {
  return /** @type{!Array<!proto.activity.ActivityLogError>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.activity.ActivityLogError, 1));
};


/**
 * @param {!Array<!proto.activity.ActivityLogError>} value
 * @return {!proto.activity.ActivityLogErrorsResponse} returns this
*/
proto.activity.ActivityLogErrorsResponse.prototype.setErrorsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.activity.ActivityLogError=} opt_value
 * @param {number=} opt_index
 * @return {!proto.activity.ActivityLogError}
 */
proto.activity.ActivityLogErrorsResponse.prototype.addErrors = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.activity.ActivityLogError, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.activity.ActivityLogErrorsResponse} returns this
 */
proto.activity.ActivityLogErrorsResponse.prototype.clearErrorsList = function() {
  return this.setErrorsList([]);
};


/**
 * @enum {number}
 */
proto.activity.ACTIVITY_ACTOR_TYPE = {
  USER: 0,
  RECEPTOR: 1,
  TRUSTERO: 2,
  PLAYBOOK: 3,
  EXTERNAL: 4,
  SCHEDULER: 5
};

/**
 * @enum {number}
 */
proto.activity.ACTIVITY_CITATION_TYPE = {
  AUDIT: 0,
  FRAMEWORK: 1,
  POLICY: 2,
  CONTROL: 3,
  EVIDENCE: 4,
  REQUEST: 5,
  RISK: 6,
  VENDOR: 7,
  CHAT: 8,
  TI_PLAYBOOK: 9,
  RECEPTOR_OBJ: 10,
  SCHEDULE: 11,
  QUESTIONNAIRE: 12,
  USER_OBJ: 13,
  QUESTIONNAIRE_REQUEST: 14,
  QUESTIONNAIRE_TEMPLATE: 15
};

goog.object.extend(exports, proto.activity);
